import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCircleInfo } from 'react-icons/fa6';
import { getResponsibilityCardGradientCSS } from './responsibilityCardColors';
import './ResponsibilityCard.css';

const ResponsibilityCard = ({ responsibility, prompts = [], colorIndex = 0 }) => {
  const navigate = useNavigate();
  const [hoveredInfoPromptId, setHoveredInfoPromptId] = useState(null);

  const handlePromptClick = (promptId, e) => {
    e.stopPropagation();
    navigate(`/prompt/${promptId}`);
  };

  const handleInfoClick = (e, prompt) => {
    e.stopPropagation();
    // Info button click - could show tooltip or modal in future
  };

  const gradientStyle = {
    background: getResponsibilityCardGradientCSS(colorIndex),
  };

  return (
    <div className="responsibility-card">
      <div className="responsibility-card-top-tip-wrapper">
        <div className="responsibility-card-top-tip" style={gradientStyle}></div>
      </div>
      <div className="responsibility-card-content">
        <h3 className="responsibility-card-title">{responsibility.responsibilityName}</h3>
        <div className="responsibility-card-prompts">
          {prompts.length > 0 ? (
            prompts.map((framework, index) => {
              const prompt = framework.prompt || framework;
              const promptId = prompt.id || prompt.promptId;
              const promptTitle = prompt.title || '';
              const promptDescription = prompt.description || '';

              return (
                <div key={promptId || index}>
                  <div className="responsibility-prompt-item">
                    <button
                      className="responsibility-prompt-title"
                      onClick={(e) => handlePromptClick(promptId, e)}
                    >
                      {promptTitle}
                    </button>
                    {promptDescription && (
                      <button
                        className="responsibility-prompt-info"
                        onClick={(e) => handleInfoClick(e, prompt)}
                        onMouseEnter={() => setHoveredInfoPromptId(promptId)}
                        onMouseLeave={() => setHoveredInfoPromptId(null)}
                        aria-label={`Info about ${promptTitle}`}
                      >
                        <FaCircleInfo />
                        {hoveredInfoPromptId === promptId && (
                          <div className="responsibility-prompt-tooltip">
                            {promptDescription}
                          </div>
                        )}
                      </button>
                    )}
                  </div>
                  {index < prompts.length - 1 && (
                    <div className="responsibility-prompt-divider"></div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="responsibility-card-empty">No prompts available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResponsibilityCard;
